import { HTMLAttributes, useState, useMemo } from "react";

import { Button } from "@/components/ui/button";
import { useNavigate } from "@tanstack/react-router";
import { AprovedInstallflowFrame } from "./aproved-install-flow-frame";
import { CheckCircle2, ClipboardIcon } from "lucide-react";
import { installFlowEmail } from "@/installFlow/storage-keys";

interface AuthProps extends HTMLAttributes<HTMLDivElement> {}

export function AprovedInstallflow({ className }: AuthProps) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const email = useMemo(
    () =>
      (typeof sessionStorage !== "undefined"
        ? installFlowEmail.get()
        : null) ?? "alex.lee@crossbreeze.com",
    [],
  );

  async function onSubmit() {
    setIsSubmitting(true);
    try {
      // Call the API to send the installation link

      await navigate({ to: "/installFlow/install-not-started" });
    } finally {
    }
  }

  function copyEmailToClipboard() {
    navigate({ to: "/installFlow/already-installed" });
  }

  return (
    <AprovedInstallflowFrame>
      <div className="flex flex-col gap-8 w-[350px] animate-in fade-in duration-500">
        <div className="flex items-start">
          <div className="text-blue-600 bg-blue-50 rounded-full p-1">
            <CheckCircle2 size={48} strokeWidth={2.5} />
          </div>
        </div>

        <div className="space-y-6">
          <h1 className="text-[20px] font-bold leading-[26px] text-black tracking-tight">
            Click the link we sent to{" "}
            <span className="text-blue-600 hover:underline cursor-pointer">
              {email}
            </span>{" "}
            to begin installing the sensor
          </h1>

          <p className="text-base font-semibold text-gray-600">
            Not seeing it? Make sure to check your spam or junk folder.
            <ClipboardIcon className="w-4 h-4" onClick={() => copyEmailToClipboard()}/>
          </p>
        </div>
      </div>
      <div className="w-full h-24">
        <Button
          className="bg-[#EDF0F3] text-black w-full h-[50px] px-6 py-2 rounded-[25px] text-base font-semibold"
          onClick={onSubmit}
        >
          Send to new email
        </Button>
      </div>
    </AprovedInstallflowFrame>
  );
}
